import { useState } from 'react';
import styled from 'styled-components';

import Layout from '@klaviyo-mkt/gatsby-theme-marketing/src/templates/layout';
import theme from '@klaviyo-mkt/gatsby-components/shared/styles/themes/default';
import Signup from '@klaviyo-mkt/gatsby-components/organisms/form/signup';

import type { PageProps } from 'gatsby';
import type { IFormState } from '@klaviyo-mkt/gatsby-components/organisms/form/types';
import { getSessionStorageValues } from '@klaviyo-mkt/gatsby-components/organisms/form/utils';

const initialState: IFormState = getSessionStorageValues();

const StyledPartnersSignup = styled.div`
  background-color: ${theme.colors.charcoal};
  position: relative;
  ${theme.globalPadding}
`;

const PartnersSignup = (pageProps: PageProps) => {
  const [formState, setFormState] = useState(initialState);

  return (
    <Layout
      {...pageProps}
      templateName="Default"
      theme={theme}
      showFooter={false}
      showHeader={false}
    >
      <StyledPartnersSignup>
        <Signup
          backgroundColor='dark'
          formState={formState}
          setFormState={setFormState}
          showAgencyFields
          templateName="Default"
        />
      </StyledPartnersSignup>
    </Layout>
  );
};

export const Head = () => (
  <title>Klaviyo + Partners | Klaviyo</title>
);

export default PartnersSignup;
